const React = require('react');
const PropTypes = require('prop-types');
const { PlayerContextProvider } = require('./cassette/cassette-core');

const MediaPlayerUI = require('./MediaPlayerUI');

class MediaPlayer extends React.Component {
  render() {
    const {
      getDisplayText,
      showVideo,
      fullscreenEnabled,
      className,
      style,
      onClose,
      ...rest
    } = this.props;
    return (
      <PlayerContextProvider {...rest}>
        <MediaPlayerUI
          getDisplayText={getDisplayText}
          showVideo={showVideo}
          fullscreenEnabled={fullscreenEnabled}
          className={className}
          style={style}
          onClose={onClose}
        />
      </PlayerContextProvider>
    );
  }
}

MediaPlayer.propTypes = {
  ...MediaPlayerUI.propTypes,
  ...PlayerContextProvider.propTypes,
  onClose: PropTypes.func.isRequired,
};

MediaPlayer.defaultProps = {
  ...MediaPlayerUI.defaultProps,
  ...PlayerContextProvider.defaultProps,
};

module.exports = MediaPlayer;
